import { ReportCategories } from '../modules';

export enum Routes {
  Root = '/',
  Consent = '/consent',
  Measurement = '/measurement',
  PaymentFlow = '/measurement/order',
  PaymentValidation = '/measurement/validating',
  QrError = '/measurement/qr-error',
  Register = 'register',
  Profile = 'profile',
  EditConsents = '/profile/consents',
  Invoices = '/profile/invoices',
  HealthData = '/profile/health-data',
  Login = 'login',
  Dashboard = 'dashboard',
  Reports = '/reports',
  FitnessReportHistory = `/reports/${ReportCategories.FITNESS}`,
  HeartHealthReportHistory = `/reports/${ReportCategories.HEART}`,
  StressReportHistory = `/reports/${ReportCategories.STRESS}`,
  SetGoal = '/dashboard/goal',
  Overview = '/reports/overview',
}
